import deliveryMethod from "./deliveryMethod"

export default {
  install(Vue) {
    Vue.use(deliveryMethod)
  }
}
